import React, { useEffect, useState } from 'react'

interface CountUpProps {
    end: number
    duration?: number
    start?: number
    delay?: number
}

const easeOutQuad = (t: number) => t * (2 - t)

const CountUp: React.FC<CountUpProps> = ({
                                             start = 0,
                                             end,
                                             duration = 1000,
                                             delay = 0,
                                         }) => {
    const [count, setCount] = useState(start)

    useEffect(() => {
        let timeoutId: NodeJS.Timeout
        let frameId: number
        let startTime: number | null = null

        timeoutId = setTimeout(() => {
            const animate = (timestamp: number) => {
                if (!startTime) startTime = timestamp
                const elapsed = timestamp - startTime
                const progress = Math.min(elapsed / duration, 1)
                const easedProgress = easeOutQuad(progress)
                const currentValue = start + (end - start) * easedProgress
                setCount(currentValue)

                if (progress < 1) {
                    frameId = requestAnimationFrame(animate)
                }
            }

            frameId = requestAnimationFrame(animate)
        }, delay)

        return () => {
            clearTimeout(timeoutId)
            cancelAnimationFrame(frameId)
        }
    }, [start, end, duration, delay])

    return <span>{Math.floor(count)}</span>
}

export default CountUp
